
import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import ConfirmationModal from "../../../../../common_components/confirmationa_modal";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../../../common_components/exhibitor_module_topmenu";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import {
  toastError,
  toastSuccess,
  powerGuidlineAmountActionId,
  formatAmount,
} from "../../../../../utils/constants";
import {
  getPowerConnectionList_action,
  submitPowerConnection_action,
  getPowerConnectionDetails_action,
} from "../../../../../actions/exhibitor_module_actions/manual_Forms_actions/forms_actions/power_connection_action/power_connection_action";
import Modal from "react-modal";
import { data, event } from "jquery";
import HeaderWithLogo from "../../../../../common_components/header_with_logo";
import AdminDrawer from "../../../../../common_components/admin_module_drawer";
import moment from "moment";
import { fill_action } from "../../../../../actions/fillCombo_action";
import VendorDrawer from "../../../../../common_components/vendor_module_drawer";
import VendorDetails from "../../vendorDetails";
//
class PowerConnection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      PowerConnectionList: [],
      confirmationObj: { message: '', buttonName: '', action: '' },
      popArg: [],
      isOpenConfirmationModal: false,
      Is_Agree: false,
      Remark: "",
      CGST: "",
      SGST: "",
      IGST: "",
      Is_AgreeErr: "",
      DeadlineDate: "",
      DeadlineDateString: "",
      currentDate: moment().format("DD-MM-YYYY"),
      Is_View: false,
      StatusID: "",
      isCollapse: false,
      CurrencyName: "",
      powerGuidlineAmountData: [],
      RoleID: sessionStorage.getItem("RoleIDSS"),
      isHideSection: sessionStorage.getItem("RoleIDSS") != 1 && sessionStorage.getItem("RoleIDSS") != 8,
      IsIGST: false,
      ValidationErr: '',
      priceList: [],
      SGLPRsinglePhasePower: 0,
      SGLPRthreePhasePower: 0,
    };
    this.getPowerConnectionList = this.getPowerConnectionList.bind(this);
    this.calculateTotals = this.calculateTotals.bind(this);

    this.handleConfirmation = this.handleConfirmation.bind(this)
  }


  handleConfirmation(flag) {
    const { confirmationObj, popArg } = this.state;
    if (flag) {
      if (confirmationObj.action == 0) {
        this.submitPowerConnection()
      }
    }
    this.setState({ isOpenConfirmationModal: false })
  }

  async componentDidMount() {
    this.getFillList(powerGuidlineAmountActionId, "", "", "", "", "");
    this.setState({
      DeadlineDate:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.Deadline != ""
          ? moment(this.props.location.state.Deadline).format("DD-MM-YYYY")
          : "",
      DeadlineDateString:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.Deadline != ""
          ? this.props.location.state.Deadline
          : "",
      Is_View:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.is_View != null
          ? this.props.location.state.is_View
          : sessionStorage.getItem("RoleIDSS") != 1,
      StatusID:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.StatusID != null
          ? this.props.location.state.StatusID
          : "",
    });

    await this.getPowerConnectionList();
  }

  getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
    const { } = this.state;
    this.setState({ isLoading: true });
    this.props
      .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
      .then((data) => {
        if (data.error != 1) {
          // country list
          if (actionID === powerGuidlineAmountActionId) {
            this.setState({
              powerGuidlineAmountData: data.data,
            });
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  async getPowerConnectionDetails() {
    this.setState({ isLoading: true });
    this.props
      .getPowerConnectionDetails_action()
      .then((data) => {
        if (data.error != 1) {
          if (data.data != "") {
            data.data.forEach(item => {
              if (item.ServiceID == 2) {
                item.Amount = (item.Rates * (parseInt(this.state.SGLPRsinglePhasePower || 0) + (parseInt(item.Quantity || 0))))
              } else {
                item.Amount = (item.Rates * (parseInt(this.state.SGLPRthreePhasePower || 0) + (parseInt(item.Quantity || 0))))
              }
            })
            console.log("data.data--->", data.data)
            this.setState({
              PowerConnectionList: data.data,
              CGST: data.data[0]["CGST"] * 100,
              SGST: data.data[0]["SGST"] * 100,
              Remark: data.data[0]["Remark"],
              Is_Agree: data.data[0]["Is_Agree"],
            });
          }
          this.setState({ isLoading: false });
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  async getPowerConnectionList() {
    this.setState({ isLoading: true });
    this.props
      .getPowerConnectionList_action()
      .then((data) => {
        if (data.error != 1) {
          data.data.map((item) => {
            if (item.Quantity == "" || item.Quantity == null) {
              item["Amount"] = 0;
            }
            if (item.Description?.includes("Single Phase")) {
              item.Quantity = data.IGST[0]['defaultSinglePhase'] != 0 ? data.IGST[0]['defaultSinglePhase'] : ''
              // item.isDisableQuantity = data.IGST[0]['defaultSinglePhase'] != 0 ? true : false
              item.isDisableQuantity = true
              item["Amount"] = data.IGST[0]['defaultSinglePhase'] != 0 ? (data.IGST[0]['defaultSinglePhase'] + data.IGST[0]['GeneralStallLightingSinglePhasePower']) * item.Rates : 0;
            } else {
              item.Quantity = data.IGST[0]['defaultThreePhase'] != 0 ? data.IGST[0]['defaultThreePhase'] : ''
              // item.isDisableQuantity = data.IGST[0]['defaultThreePhase'] != 0 ? true : false
              item.isDisableQuantity = true
              item["Amount"] = data.IGST[0]['defaultThreePhase'] != 0 ? (data.IGST[0]['defaultThreePhase'] + data.IGST[0]['GeneralStallLightingThreePhasePower']) * item.Rates : 0;
            }
          }, () => this.calculateTotals());
          this.setState(
            {
              priceList: data.data,
              PowerConnectionList: data.data,
              IsIGST: data.IGST[0]['IsIGST'],
              SGLPRsinglePhasePower: data.IGST[0]['GeneralStallLightingSinglePhasePower'],
              SGLPRthreePhasePower: data.IGST[0]['GeneralStallLightingThreePhasePower'],
              CGST: data.data[0]["CGST"] * 100,
              SGST: data.data[0]["SGST"] * 100,
              IGST: data.data[0]["IGST"] * 100,
              CurrencyName: data.data[0]["CurrencyName"],
            },
            () => this.getPowerConnectionDetails()
          );
          this.setState({ isLoading: false });
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  submitPowerConnection() {
    const { PowerConnectionList, Remark, Is_Agree, ValidationErr } = this.state;
    const { totalAmount } = this.calculateTotals;

    const newArray = [];
    PowerConnectionList.map((data, i) => {
      newArray.push({
        ServiceID: data.ServiceID,
        Rates: data.Rates,
        Quantity: data.Quantity != "" ? parseInt(data.Quantity) : 0,
        Amount: data.Amount,
      });
    });
    this.inputValidate();
    const flag = PowerConnectionList.every(
      (item) => item.Quantity == "" || item.Quantity == 0
    );
    const ManualFormsID = this.props.location.state?.ManualFormsID || null;
    const ServiceID = this.props.location.state?.ServiceID || null;
    const VendorDetails = this.props.location.state?.VendorDetails || {};
    if (Is_Agree) {
      if (!flag) {
        if (ValidationErr == '') {
          this.setState({ isLoading: true });
          this.props
            .submitPowerConnection_action(
              Remark,
              Is_Agree == true ? 1 : 0,
              newArray,
              ManualFormsID,
              ServiceID,
              VendorDetails
            )
            .then((data) => {
              if (data.error != 1) {
                this.setState({ isLoading: false });
                toastSuccess(
                  this.state.StatusID == 0
                    ? "Power Connection Form Submitted Successfully"
                    : "Power Connection Form Updated Successfully"
                );
                setTimeout(() => {
                  this.props.navigate("/manualForms");
                }, 2000);
              } else {
                this.setState({ isLoading: false });
                toastError(data.msg);
              }
            })
            .catch((e) => {
              console.log(e);
            });
        } else {
          toastError("Please enter valid quantity");
        }
      } else {
        this.setState({ isLoading: false });
        toastError("Please enter quantity");
      }
    } else {
      this.setState({ isLoading: false });
      toastError("kindly agree the terms and conditions");
    }
  }

  calculateTotals() {
    try {
      const { PowerConnectionList } = this.state;
      let totalAmount = 0;
      PowerConnectionList.forEach((data) => {
        totalAmount += Number(data.Amount);
      });
      return {
        totalAmount,
      };
    } catch (e) {
      console.log("exception : ", e);
    }
  }

  handleCancel() {
    window.history.back();
  }

  enterQuantity(e, index) {
    const { PowerConnectionList } = this.state;
    const list = [...PowerConnectionList];
    const event = e.target.value.replace(/\D/, "");
    for (let i = 0; i < list.length; i++) {
      if (i == index) {
        list[i]["Quantity"] = event;
        if (event != "" && event != 0) {
          list[i]["Amount"] = event * list[i]["Rates"];
        } else {
          list[i]["Amount"] = 0;
        }

        if (i == 0) {
          if (event > 3) {
            this.setState({ ValidationErr: 'Maximum 3 quantities allowed for single phase. Apply for three phase for more' })
          } else {
            this.setState({ ValidationErr: '' })
          }
        }
      }
    }
    this.setState({
      PowerConnectionList: list,
    });
  }

  inputValidate() {
    const { Is_Agree } = this.state;

    if (Is_Agree == 0 || Is_Agree == false) {
      this.setState({ Is_AgreeErr: "kindly agree the terms and condition" });
    }
  }

  render() {
    const {
      isLoading,
      Is_Agree,
      Remark,
      PowerConnectionList,
      SGST,
      CGST,
      Is_AgreeErr,
      currentDate,
      DeadlineDate,
      Is_View,
      StatusID,
      isCollapse,
      CurrencyName,
      powerGuidlineAmountData,
      DeadlineDateString,
      IGST,
      RoleID,
      isHideSection,
      IsIGST,
      ValidationErr, isOpenConfirmationModal, priceList
    } = this.state;
    console.log("IGST---->", IGST)
    const { totalAmount } = this.calculateTotals();
    const isDeadlinePassed =
      DeadlineDate &&
      moment(DeadlineDate, "DD-MM-YYYY").isValid() &&
      moment(currentDate, "DD-MM-YYYY").isAfter(
        moment(DeadlineDate, "DD-MM-YYYY")
      );
    console.log("first", this.props);
    return (
      <>
        {isOpenConfirmationModal ? <ConfirmationModal onConfirmation={this.handleConfirmation} message={this.state.confirmationObj} /> : null}
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        {!isHideSection && (
          <>
            {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ||
              JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 8 ? (
              <ExhibitorHeader />
            ) : (
              <HeaderWithLogo />
            )}
            {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ||
              JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 8 ? (
              <ExhibitorDrawer />
            ) : JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID ==
              7 ? (
              <VendorDrawer />
            ) : (
              <AdminDrawer />
            )}
          </>
        )}
        <div
          className={!isHideSection ? "with-dr-container" : ""}
          style={{ marginTop: RoleID == 1 ? "0px" : "" }}
        >
          <div className="main-container">
            {!isHideSection && (
              <div className="row">
                {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID ==
                  1 ||
                  JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID ==
                  8 ? (
                  <ExhibitorTopMenu />
                ) : null}
              </div>
            )}
            <div className="p-2">
              <div className="row m-0">
                <div class="card rounded-1 border mt-7 p-0">
                  <div class="card-header d-flex">
                    <h3 class="card-title">Power Connection Guideline's</h3>
                    {!isHideSection && (
                      <p
                        className="text-aqua mb-0 mx-2"
                        style={{
                          // textDecoration: "underline",
                          // color: "blue",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          this.setState({ isCollapse: !isCollapse })
                        }
                      >
                        Click Here to {isCollapse ? "hide" : "read"} Guidelines
                      </p>
                    )}
                  </div>
                  {/* <div class="table-responsive">
                    <table class="table border text-nowrap text-md-nowrap table-bordered mb-2 mt-2 w-50">
                      <thead>
                        <tr>
                          <th>Size of phase conductor</th>
                          <th>
                            Size of protective conductor of the same
                            material as phase conductor
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Up to 4mm²</td>
                          <td>Same size as that of phase conductor</td>
                        </tr>
                        <tr>
                          <td>Above 4mm² & up to 16mm²</td>
                          <td>Same size as that of phase conductor</td>
                        </tr>
                        <tr>
                          <td>Above 16mm² & up to 35mm²</td>
                          <td>16mm²</td>
                        </tr>
                        <tr>
                          <td>Above 35mm²</td>
                          <td>Half size of phase conductor</td>
                        </tr>
                      </tbody>
                    </table>
                  </div> */}
                  <div class="card-body p-1 m-2">
                    {isCollapse && (
                      <div className="text-left mt-2">

                        <ol style={{ listStyleType: "none", paddingLeft: 0, marginLeft: 10 }}>
                          <li>
                            <strong>23.4 Power Tariffs & electrical guideline.</strong>
                            <ul style={{ listStyleType: "none" }}>
                              <li>
                                The exhibitor may indicate their power requirement and electrical guideline in the online exhibitor manual form which will be opened for confirmed exhibitor only.
                              </li>
                            </ul>

                            <strong>23. 5 Power Distribution</strong>
                            <ul style={{ listStyleType: "none" }}>
                              <li>
                                23.5.1 Exhibitors should note that 1kw supply/outlet is compulsory in every single stall as a facility for lighting. Every exhibitor must submit their layout plan with indication of point of power supply.
                              </li>
                              <li>23.5.2	The stall contractors undertaking lighting work shall possess valid electrical wireman license.</li>
                              <li>23.5.3	The load ≤ 3 kW shall be fed through single phase electrical supply at 230V AC ± 6 % and load {'>'} 3kW shall be fed through 3 Phase electrical Supply at 415V AC ± 6 % The supply Frequency will be 50Hz ± 3%. d.</li>
                              <li>23.5.4	From point of power supply Only 3 Wires for Sigle Phase and 5 Wires for Three Phase are permissible from outgoing for internal distribution.</li>
                              <li>23.5.5	It is compulsory to internal distribution board inside the stall from exhibitor.</li>
                              <li>23.5.6	The exhibitor requiring supply at voltage level other than above shall make necessary arrangement for the level matching equipment such as transformer, voltage stabilizer, inverter etc. to match the supply voltage level to their load.</li>
                              <li>23.5.7	The frame of stationary motor and the metallic parts, not intended as conductors, including transformers and any other apparatus used for regulating or controlling electricity of voltage exceeding 250V but not exceeding 650V shall be earthed firmly by the conductor size as mentioned.</li>
                              <li>23.5.8	Exhibitor are advised to make arrangement for power conditioning equipment such as UPS, CVT etc. for their critical & supply sensitive load/ equipment operating under very narrow band of tolerance.</li>
                              <li>23.5.9	The contractors shall use BIS marked PVC insulated 650/1100 V copper conductor wire for supplying electrical power to lighting & motive load to be installed in stall.</li>
                              <li>23.5.10	All switch boards shall conform to BIS & to Indian Electricity Act (amended).</li>
                              <li>23.5.10	All switch boards shall conform to BIS & to Indian Electricity Act (amended).</li>
                              <li>23.5.11	The insulation tape used shall carry IS marking.</li>
                              <li>23.5.12	For lighting circuit, the minimum wire size shall be 1.5/2.5 sq.mm PVC insulated 650V grade FRLS copper wire. For 16A power point, the minimum wire size shall be 4sq.mm PVC insulated 650V grade FRLS copper wire. The IR value of cable used shall not be less than 1MΩ when measured with 500V DC megger.</li>
                              <li>23.5.13	Exhibitor can bring international adopter for their internal electrical connection.</li>
                              <li>23.5.14	The contractor shall use following size of protective conductors for equipment at their stall from point of supply (MCB Box).</li>
                              <li>
                                <div style={{ width: "800px", marginTop: "10px" }}>
                                  <table style={{ borderCollapse: "collapse" }}>
                                    <thead>
                                      <tr>
                                        <th style={{ background: 'none', border: "1px solid #000", padding: "8px", textAlign: "left", fontWeight: "bold" }}>
                                          Size of phase conductor
                                        </th>
                                        <th style={{ background: 'none', border: "1px solid #000", padding: "8px", textAlign: "center", fontWeight: "bold" }}>
                                          Size of protective conductor of the same material as phase conductor
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td style={{ border: "1px solid #000", padding: "8px" }}>Up to 4mm²</td>
                                        <td style={{ border: "1px solid #000", padding: "8px" }}>
                                          Same size as that of phase conductor
                                        </td>
                                      </tr>
                                      <tr>
                                        <td style={{ border: "1px solid #000", padding: "8px" }}>Above 4mm² & up to 16mm²</td>
                                        <td style={{ border: "1px solid #000", padding: "8px" }}>
                                          Same size as that of phase conductor
                                        </td>
                                      </tr>
                                      <tr>
                                        <td style={{ border: "1px solid #000", padding: "8px" }}>Above 16mm² & up to 35mm²</td>
                                        <td style={{ border: "1px solid #000", padding: "8px" }}>
                                          16mm²
                                        </td>
                                      </tr>
                                      <tr>
                                        <td style={{ border: "1px solid #000", padding: "8px" }}>Above 35mm²</td>
                                        <td style={{ border: "1px solid #000", padding: "8px" }}>
                                          Half size of phase conductor
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </li>
                              <li>23.5.15	The earth wires shall be connected to the main earth firmly. After switching the entire load at stall, the voltage between neutral & earth shall not exceed 10V.</li>
                              <li>23.5.16	Exhibitor shall ensure that, the contractor shall carry out all electrical works in the stall area as per Indian Electricity Rules 2005/ CEA Regulation 2010/ General Specifications for Electrical Works, Part I & II by CPWD.</li>
                              <li>23.5.17	The Contractor shall carry out wiring at their installation as per IS-732:2010 with all safety precautions.</li>
                              <li>23.5.18	The load connected to power point shall be suitable for the socket and under no circumstances exceed the rated current capacity of the socket.</li>
                              <li>23.5.19	Exhibitors must install separate and independent MCBs/MCCBs/RCCBs of appropriated rating for their individual machines so as to automatically disconnect the supply in case of a) Overload b) Earth leakage or earth fault c) short circuit.</li>
                              <li>23.5.20	It is mandatory to use only reputed make wires like Polycom, KEI, Anchor etc and MCB/RCCB like Legrand, Siemens, ABB, Schneider for the electrical installation.</li>
                              <li>23.5.21	Wherever 3 ph connection is requested, the load shall be evenly distributed on all three phases. The current through neutral conductor or in other words, the current unbalance shall not exceed 5%.<br></br>
                                23.5.22	The contractor shall also ensure that conductor size of the cable/ wire is suitable to cater connected load without overloading/overheating in normal operation and during abnormal conditions. This may be checked and verified by electrical consultant.
                              </li>
                              <li>23.5.23	In case any material used by the contractor is found to be of inferior or sub-standard quality, the contractor shall be responsible for replacing the same without any loss of time as per the quality mutually agreed and mentioned above.</li>
                              <li>23.5.24	It is recommended to make use of low loss/ low heating choke manufactured as per IS and of reputed make namely Philips, Crompton, Bajaj, Wipro or equivalent.</li>
                              <li>23.5.25	The contractor shall control maximum 10 points or 800 watts whichever less, from single point.</li>
                              <li>23.5.26	Joint to the wires in any place is unacceptable. However, good quality connector of adequate rating properly covered cab be used.</li>
                              <li>23.5.27	Use 3-pin top / industrial to shall be made to take supply from sockets. The third pin shall be connected to earth through protective (loop earthing) conductor. It is strictly prohibited to insert wires directly into socket for drawing supply.</li>
                              <li>23.5.28	Adequate access to main power supply (relieving point) at stall shall be provided for cleaning & maintenance purpose. A clear space of not less than 1 meter shall be provided in front of the switchboard. Materials particularly combustible shall not be dumped at this location.</li>
                              <li>23.5.29	All main electrical supply points must be kept easily accessible for operation and repairs and for isolation of power in the event of emergency. These should not be concealed or covered under any circumstances.</li>
                              <li>23.5.30	Exhibitors requesting for 3-phase supply shall draw single phase power for lighting purpose from 3-phase supply outlet using double pole MCBs. The double pole MCB/RCCB shall be arranged by the exhibitor.</li>
                              <li>23.5.31	The electrical supply will be released only after completion of wiring work conforming to the Indian standards & codes of wiring and to the satisfaction of Electrical consultant.</li>
                              <li>23.5.32	UPS/Stabiliser with rating greater than 3kVA should have 3 Phase Input.</li>
                              <li>23.5.33	Point of power supply will be provided to below 15 kw.</li>
                              <li>23.5.34	Exhibitors may contact the Electrical Consultant at venue office for any technical queries.</li>
                              <li>23.5.35	Exhibitors under Shell Scheme package would be provided with a plug point socket and a switch for a 230 V, 6 Amp A.C. supply. Consumption of power through this plug point for the connected load upto 1 kw is included in the cost of shell scheme package. However, additional power would be made available to them on extra payment.</li>
                              <li>23.5.36	Exhibitors shall bring their own electrical cables, wires, sockets, international electrical adaptor to connect their electrical installation.</li>
                              <li>23.5.37	The Exhibition authority arrange for supply of power will be entrusted with the authority for regulating and controlling the power supply to the exhibition halls and individual stalls.</li>
                            </ul>

                            <strong>23.6	Electrical Installation Regulations</strong>
                            <ul style={{ listStyleType: "none" }}>
                              <li>
                                23.6.1	Electrical wiring and installation must be done by Exhibitors through registered professional technicians using proper wiring, switches etc. so as to ensure safety. The Organisers shall not be responsible or liable in case of any mishap due to use of sub-standard material or unskilled labour.
                              </li>
                              <li>23.6.2	Lamps and appliances with high temperature surfaces should be guarded and used well away from combustible materials.</li>
                              <li>23.6.3	No light fitting or other appliance may be suspended from the roof of the exhibition hall.</li>
                              <li>23.6.4	Exhibitors are requested to review their internal wiring and connections thoroughly before going live. Also, Members should estimate the power requirement in advance so that, appropriate load management can be done. Switching from temporary to permanent power supply should be done in advance clear two days, so that testing and balancing can be done properly.</li>
                              <li>23.6.5	Exhibitor shall submit Electrical Work Completion Report to Hall Directors for permanent power connection as per the format. Power will be released on receipt of the completion report.</li>
                              <li>23.6.6	The Organisers reserve the right to disconnect any installation, which in their opinion is dangerous or likely to cause annoyance to visitors or other Exhibitors.</li>
                              <li>23.6.7	In order to take care of voltage fluctuations, the Exhibitors are advised to fix up constant voltage transformers or insulation Transformer or stabilizers for CNC and other sensitive machines. Exhibitors are encouraged to use MCCB wherever necessary. The main supply points and electrical installations in the stand should be kept open for easy access and should not be concealed.</li>
                              <li>23.6.8	Electrical power should be drawn from designated points allocated to the exhibitor only. Any exhibitor or its designated contractor found drawing power from unauthorized sources will be liable to forfeiter of security deposit and or in the event of non-compliance with the applicable Rules and Regulations, the corresponding onsite charges, penalties, recovery costs, or any other applicable fees shall be levied and recovered from the concerned party. Such charges shall be determined in accordance with the provisions of these Rules and Regulations and the applicable schedule of charges. In the event of any unauthorized usage, encroachment, modification, or non-compliance related to space utilization, the applicable penalty and recovery charges shall be imposed in accordance with Clause 18.3 of the Rules and Regulations and shall be recovered from the concerned party.</li>
                            </ul>
                          </li>
                        </ol>
                      </div>
                    )}
                    {!isHideSection && (
                      <>
                        {/* <p className="fw-semibold">The tariff for electric power will be as under:</p>
                        <p className="fw-semibold">Connection/Consumption charges for power supply to</p> */}
                        <p className="fw-semibold mb-0">Instructions:</p>
                        <ol style={{ textAlign: "left" }}>
                          <li>
                            From point of power supply Only 3 Wires for Sigle Phase and 5 Wires for Three Phase are permissible from outgoing for internal distribution.
                          </li>
                          <li>
                            It is compulsory to internal distribution board inside the stall from exhibitor.
                          </li>
                          <li>
                            Exhibitors must submit their layout plan with the power supply point indicated.
                          </li>
                          <li>
                            Utility requirements received after the deadline ({this.props.location?.state?.ActualDeadline
                              ? moment(
                                this.props.location.state.ActualDeadline
                              ).format("DD-MM-YYYY")
                              : "-"}) will be subject to the following additional charges:
                          </li>
                        </ol>

                      </>
                    )}

                    <div className="card card-cus card-cus-2 mt-4 mb-2 cus-width">

                      <div
                        className="card-header  cus-hed"
                        style={{
                          fontSize: 16,
                          borderTop: "1px solid #eee",
                          position: "relative",
                          textAlign: 'left'
                        }}
                      >
                        <strong>
                          Stall General Lighting Power Requirement
                        </strong>
                      </div>
                      <div className="form-row mt-1 p-2">
                        <div className="col-xl-3">
                          <label htmlFor="validationCustom03">
                            Single Phase Power<span className="text-danger">*</span>
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            maxLength={'1'}
                            value={this.state.SGLPRsinglePhasePower}
                            disabled
                          />
                        </div>
                        <div className="col-xl-3">
                          <label htmlFor="validationCustom03">
                            Three Phase Power<span className="text-danger">*</span>
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            maxLength={'10'}
                            value={this.state.SGLPRthreePhasePower}
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                    {!isHideSection && (
                      <div class="table-responsive mt-3">
                        <table class="table border text-nowrap text-md-nowrap table-bordered mb-0  w-50 air-connection-table">
                          <thead>
                            <tr>
                              <th className="text-center">
                                Sr.No
                              </th>
                              <th>
                                Description
                              </th>
                              {!isHideSection &&
                                (CurrencyName == 'INR' ? (
                                  <>
                                    <th className="text-center">
                                      Standard Rate <br></br>(INR)<br />
                                      (Up to 21-09-2026)
                                    </th>
                                    <th className="text-center">Post Cut-off Date Rate <br />
                                      (INR)<br /></th>
                                    <th className="text-center">Onsite Rate <br />
                                      (INR)<br />
                                      (Applicable from 28-11-2026)</th>
                                  </>
                                ) : (
                                  <>
                                    <th className="text-center">
                                      Standard Rate <br></br>(USD)<br />
                                      (Up to 21-09-2026)
                                    </th>
                                    <th className="text-center">Post Cut-off Date Rate <br />
                                      (USD)<br /></th>
                                    <th className="text-center">Onsite Rate <br />
                                      (USD)<br />
                                      (Applicable from 28-11-2026)</th>
                                  </>
                                ))}
                            </tr>
                          </thead>

                          <tbody>
                            {priceList.length > 0 ?
                              priceList.map((item, i) => (
                                <tr>
                                  <td className="text-center">{i + 1}</td>
                                  <td>{item.Description}</td>
                                  {!isHideSection && (
                                    <>
                                      {CurrencyName == 'INR' ?
                                        <>
                                          <td style={{ textAlign: "center" }}>
                                            {item.StandardRateInINR ? formatAmount(item.StandardRateInINR) : ""}
                                          </td>
                                          <td style={{ textAlign: "center" }}>
                                            {item.CutOffDateRateInINR ? formatAmount(item.CutOffDateRateInINR) : ""}
                                          </td>
                                          <td style={{ textAlign: "center" }}>
                                            {item.OnSiteRateInINR ? formatAmount(item.OnSiteRateInINR) : ""}
                                          </td>
                                        </> :
                                        <>
                                          <td style={{ textAlign: "center" }}>
                                            {item.StandardRateInUSD ? formatAmount(item.StandardRateInUSD) : ""}
                                          </td>
                                          <td style={{ textAlign: "center" }}>
                                            {item.CutOffDateRateInUSD ? formatAmount(item.CutOffDateRateInUSD) : ""}
                                          </td>
                                          <td style={{ textAlign: "center" }}>
                                            {item.OnSiteRateInUSD ? formatAmount(item.OnSiteRateInUSD) : ""}
                                          </td>
                                        </>
                                      }
                                    </>
                                  )}
                                </tr>
                              )) :
                              <tr>
                                <td className="text-center" colSpan={10}>Record not found</td>
                              </tr>
                            }
                          </tbody>
                        </table>
                      </div >
                    )}
                    {/* <p>
                          For more details or any queries please contact:
                          itme@india-itme.com, gttes@india-itme.com{" "}
                        </p> */}
                    <VendorDetails />
                    {!isHideSection && (
                      <div className="row mt-4">
                        <h6 className="mt-2 ">
                          Power Connection{" "}
                          <span className="text-danger">
                            {" "}
                            Last Date Of Submission -{" "}
                            {this.props.location?.state?.ActualDeadline
                              ? moment(
                                this.props.location.state.ActualDeadline
                              ).format("DD-MM-YYYY")
                              : "-"}
                          </span>
                        </h6>
                        <h3 className="card-title text-left" style={{ fontSize: 15 }}>
                          <span className="text-danger">(All utility requirements must be filled in the Main Space Booking Application Form under the Exhibit Details section.<span className="text-primary" onClick={() => this.props.navigate("/spacebooking", {
                            state: {
                              flag: 1
                            }
                          })}>Click Here</span> to open Main Space Booking Application Form. However, confirmation of these requirements must be submitted through this Request Confirmation Form.)</span>
                        </h3>
                      </div>
                    )}
                    <div class="table-responsive">
                      <table class="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-1">
                        <thead>
                          <tr>
                            <th>Description of Service</th>
                            {!isHideSection && <th style={{ textAlign: "center" }}>Rates ({CurrencyName})</th>}
                            <th style={{ width: '400px', textAlign: "center" }}>Quantity</th>
                            <th style={{ width: '10px', textAlign: "center" }}>General Lighting Power Quantity</th>
                            {!isHideSection && <th style={{ textAlign: "center" }}>Amount({CurrencyName})</th>}
                          </tr>
                        </thead>
                        <tbody>
                          {PowerConnectionList.length > 0 &&
                            PowerConnectionList != null ? (
                            PowerConnectionList.map((data, i) => (
                              <>
                                <tr>
                                  <td>{data.Description}</td>
                                  {!isHideSection && (
                                    <td style={{ textAlign: "right" }}>
                                      {formatAmount(data.Rates)}
                                    </td>
                                  )}
                                  <td>
                                    <input
                                      style={{ textAlign: 'right' }}
                                      type="text"
                                      class="form-control"
                                      value={data.Quantity}
                                      disabled={true}
                                      maxLength={i == 0 ? 1 : 4}
                                      onChange={(e) => this.enterQuantity(e, i)}
                                    />
                                    {i == 0 &&
                                      <span className="text-danger text-start text-left d-block mt-1">
                                        {ValidationErr}
                                      </span>
                                    }
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      class="form-control"
                                      style={{ textAlign: 'right' }}
                                      value={
                                        data.ServiceID == 2 ? (parseInt(this.state.SGLPRsinglePhasePower) || 0) : (parseInt(this.state.SGLPRthreePhasePower) || 0)
                                      }
                                      disabled={true}
                                    />
                                  </td>
                                  {!isHideSection && (
                                    <td style={{ textAlign: "right" }}>
                                      {formatAmount(data.Amount)}
                                    </td>
                                  )}
                                </tr>
                              </>
                            ))
                          ) : (
                            <></>
                          )}
                          {!isHideSection && (
                            <>
                              <tr style={{ textAlign: "right" }}>
                                <td colspan="3"></td>
                                <td className="fw-semibold">Total
                                </td>
                                <td className="fw-semibold" style={{ textAlign: "right" }}>
                                  {formatAmount(totalAmount)}
                                </td>
                              </tr>
                              {!IsIGST ? (
                                <>
                                  <tr style={{ textAlign: "right" }}>
                                    <td colspan="3"></td>
                                    <td className="fw-semibold">
                                      CGST @ {CGST}%
                                    </td>
                                    <td className="fw-semibold" style={{ textAlign: "right" }}>
                                      {formatAmount(
                                        (CGST / 100) * totalAmount
                                      )}
                                    </td>
                                  </tr>
                                  <tr style={{ textAlign: "right" }}>
                                    <td colspan="3"></td>
                                    <td className="fw-semibold">
                                      SGST @ {SGST}%
                                    </td>
                                    <td className="fw-semibold" style={{ textAlign: "right" }}>
                                      {formatAmount(
                                        (SGST / 100) * totalAmount
                                      )}
                                    </td>
                                  </tr>
                                </>
                              ) : (
                                <tr style={{ textAlign: "right" }}>
                                  <td colspan="3"></td>
                                  <td className="fw-semibold">
                                    IGST @ {IGST}%
                                  </td>
                                  <td className="fw-semibold" style={{ textAlign: "right" }}>

                                    {formatAmount((IGST / 100) * totalAmount)}

                                  </td>
                                </tr>
                              )}
                              <tr style={{ backgroundcolor: "#eee" }} style={{ textAlign: "right" }}>
                                <td colspan="3"></td>
                                <td className="fw-semibold">Grand Total
                                </td>
                                <td className="fw-semibold" style={{ textAlign: "right" }}>
                                  {formatAmount(
                                    (CGST / 100) * totalAmount +
                                    (SGST / 100) * totalAmount +
                                    totalAmount
                                  )}
                                </td>
                              </tr>
                            </>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="row m-0 p-0">
                  <label className="px-0">Remark</label>
                  <textarea
                    class="form-control"
                    value={Remark}
                    maxLength={1000}
                    onChange={(e) => this.setState({ Remark: e.target.value })}
                    disabled={Is_View || isDeadlinePassed || StatusID == 2}
                    rows="3"
                  ></textarea>
                  <label
                    class="d-flex mt-1 p-0 mt-3"
                    style={{ lineheight: "15px;" }}
                  >
                    <input
                      type="checkbox"
                      checked={Is_Agree}
                      disabled={Is_View || isDeadlinePassed || StatusID == 2}
                      onChange={(e) =>
                        this.setState({
                          Is_Agree: e.target.checked,
                          Is_AgreeErr: "",
                        })
                      }
                    />
                    I confirm the above requirements and disclaimer<span className="required">*</span>.
                  </label>
                  {
                    <span className="text-danger text-start text-left d-block mt-1">
                      {Is_AgreeErr}
                    </span>
                  }
                </div>
              </div>
              <div className="row m-0">
                {isDeadlinePassed && (
                  <span className="text-danger">
                    THE DEADLINE TO FILL OUT THE FORM HAS PASSED.
                  </span>
                )}
              </div>
              {!isHideSection && (
                <div className="d-flex justify-content-end mt-0">
                  {!Is_View ? (
                    <button
                      type="button"
                      className="btn btn-aqua rounded-1 d-block mt-3 mb-3"
                      style={{ marginRight: 10 }}
                      disabled={isDeadlinePassed || StatusID == 2}
                      // onClick={() => this.submitPowerConnection()}
                      onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to  ${this.state.StatusID == 0 ? "Submit" : "Update"}?`, buttonName: this.state.StatusID == 0 ? "Submit" : "Update", action: 0 }, popArg: [] })}
                    >
                      {this.state.StatusID == 0 ? "Submit" : "Update"}
                    </button>
                  ) : (
                    <></>
                  )}
                  <button
                    type="button"
                    className="btn rounded-1 mt-3 mb-3 btn-gray"
                    onClick={() => this.handleCancel()}
                  >
                    Back
                  </button>
                </div>
              )}
            </div>
          </div>
        </div >
      </>
    );
  }
}

export default withRouter(
  connect(null, {
    getPowerConnectionList_action,
    submitPowerConnection_action,
    getPowerConnectionDetails_action,
    fill_action,
  })(PowerConnection)
);
